import {
  DESTINATIONS,
  EXTRAORDINARY_SLIDES,
  HERO_ACTIVITY_CHIPS,
  MADE_ON_VENDALIST,
  POSSIBILITIES_STEPS,
  WALLS_COULD_TALK,
} from '../components/home/homeDummyContent';

const text = (label, key) => ({ key, label, type: 'text' });
const area = (label, key) => ({ key, label, type: 'textarea' });
const image = (label, key) => ({ key, label, type: 'image' });

const list = (label, key, itemFields) => ({
  key,
  label,
  type: 'list',
  itemFields,
});

const section = (id, title, place, hint, fields = []) => ({
  id,
  title,
  place,
  hint,
  fields,
});

export const PUBLIC_PAGES = [
  {
    slug: 'home',
    label: 'Homepage',
    path: '/',
    sections: [
      section('hero', 'Hero', 'hero', 'Full-bleed photo, headline, search, and activity chips.', [
          text('Eyebrow', 'hero_eyebrow'),
          text('Headline', 'hero_title'),
          area('Supporting line', 'hero_subtitle'),
          list('Background photos', 'hero_images', [image('Image', 'src')]),
          list('Activity chips', 'activity_chips', [
            text('Label', 'label'),
            text('Search query', 'q'),
          ]),
      ]),
      section('layer', 'Band under the hero', 'main', 'Dark band directly under the search hero.', [
          text('Headline', 'layer_title'),
          area('Supporting line', 'layer_body'),
      ]),
      section('made', 'Made on VendaList', 'main', 'Photo cards of work booked on the marketplace.', [
          text('Eyebrow', 'made_eyebrow'),
          text('Headline', 'made_title'),
          area('Supporting line', 'made_body'),
          list('Cards', 'made_items', [
            text('Title', 'title'),
            text('Meta', 'meta'),
            image('Image', 'image'),
            text('Link', 'href'),
          ]),
      ]),
      section('why', 'Why VendaList', 'main', 'Photo plus numbered points.', [
          text('Eyebrow', 'why_eyebrow'),
          text('Headline', 'why_title'),
          area('Supporting line', 'why_body'),
          image('Photo', 'why_image'),
          text('Photo caption', 'why_caption'),
          text('Photo meta', 'why_meta'),
          list('Points', 'why_steps', [
            text('Number', 'number'),
            text('Title', 'title'),
            area('Description', 'description'),
          ]),
      ]),
      section('catalog', 'Categories and featured vendors', 'live', 'Live marketplace rail. Drag to move it. Listings come from vendors, not this form.'),
      section('steps', 'Booking steps', 'main', 'Three-step “how booking works” band.', [
          text('Headline', 'steps_title'),
          area('Supporting line', 'steps_body'),
          list('Steps', 'steps', [
            text('Number', 'number'),
            text('Title', 'title'),
            area('Description', 'description'),
          ]),
      ]),
      section('slides', 'Editorial slides', 'main', 'Full-screen photo slides with a kicker, title, and body.', [
          list('Slides', 'slides', [
            text('Kicker', 'kicker'),
            text('Title', 'title'),
            area('Body', 'body'),
            image('Image', 'image'),
          ]),
      ]),
      section('inventory', 'Category services', 'live', 'Live services by category, plus the vendor spotlight. Drag to move this block.'),
      section('audience', 'Audience cards', 'main', 'Three photo stories on the dark band.', [
          text('Headline', 'audience_title'),
          text('Button label', 'audience_cta_label'),
          text('Button link', 'audience_cta_link'),
          list('Cards', 'audience_cards', [
            text('Title', 'title'),
            area('Body', 'body'),
            image('Image', 'image'),
            text('Link', 'href'),
          ]),
      ]),
      section('stories', 'Stories', 'main', 'Journal cards.', [
          text('Headline', 'stories_title'),
          area('Supporting line', 'stories_body'),
          text('Link label', 'stories_link_label'),
          list('Stories', 'stories', [
            text('Eyebrow', 'eyebrow'),
            text('Title', 'title'),
            area('Body', 'body'),
            image('Image', 'image'),
            text('Link', 'href'),
          ]),
      ]),
      section('destinations', 'Places', 'main', 'City cards.', [
          text('Headline', 'destinations_title'),
          area('Supporting line', 'destinations_body'),
          list('Places', 'destinations', [
            text('City', 'city'),
            text('Label', 'label'),
            text('Region', 'region'),
            image('Image', 'image'),
            text('Link', 'href'),
          ]),
      ]),
      section('host', 'Vendor call to action', 'main', 'Dark band inviting vendors to list.', [
          text('Eyebrow', 'host_eyebrow'),
          text('Headline', 'host_title'),
          area('Supporting line', 'host_body'),
          text('Primary button', 'host_primary_label'),
          text('Primary link', 'host_primary_link'),
          text('Secondary button', 'host_secondary_label'),
          text('Secondary link', 'host_secondary_link'),
          image('Photo', 'host_image'),
      ]),
      section('closing', 'Closing', 'main', 'Last band on the page.', [
          text('Headline', 'closing_title'),
          area('Supporting line', 'closing_body'),
          text('Primary button', 'closing_primary_label'),
          text('Primary link', 'closing_primary_link'),
          text('Secondary button', 'closing_secondary_label'),
          text('Secondary link', 'closing_secondary_link'),
      ]),
    ],
    defaults: {
      hero_eyebrow: 'VendaList',
      hero_title: 'Where extraordinary begins',
      hero_subtitle:
        'Unique vendors for parties, weddings, photo & film — book by the package, not the panic.',
      activity_chips: HERO_ACTIVITY_CHIPS,
      layer_title: 'Unique vendors for events, meetings, photo & film',
      layer_body:
        'From indie films to boardroom celebrations — browse verified providers, lock dates, and pay by the package without the chaos.',
      made_eyebrow: 'Made on VendaList',
      made_title: 'From indie nights to boardroom launches',
      made_body:
        'Remarkable things are booked here every week — booths, crews, and creatives that make the night feel intentional.',
      made_items: MADE_ON_VENDALIST,
      why_eyebrow: 'Why VendaList',
      why_title: 'Your something starts somewhere',
      why_body:
        'Whether it’s a backyard birthday or a ballroom wedding, start with the vendors who make the night feel inevitable.',
      why_image:
        'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1400&q=80',
      why_caption: 'Light & airy celebration',
      why_meta: 'Toronto, CA',
      why_steps: POSSIBILITIES_STEPS,
      steps_title: 'Book in three calm steps',
      steps_body: 'From first search to confirmed booking — the same quiet flow every time.',
      steps: [
        {
          number: '01',
          title: 'Search',
          description:
            'What you need and where the party is — markets and categories, not guesswork.',
        },
        {
          number: '02',
          title: 'Compare',
          description:
            'Portfolios, packages, and reviews side by side so the shortlist feels obvious.',
        },
        {
          number: '03',
          title: 'Book',
          description:
            'Lock the date with secure checkout, confirmation, and a clear path to event day.',
        },
      ],
      slides: EXTRAORDINARY_SLIDES,
      audience_title: 'For parties from backyard to ballroom',
      audience_cards: [
        {
          title: 'Start small, look sharp',
          body: 'Birthdays, showers, and pop-ups — book a booth or DJ without the agency runaround.',
          image: '/images/01_-_HERO_1.webp',
          href: '/browse-vendors',
        },
        {
          title: 'Plan the day that matters',
          body: 'Weddings and milestones with verified crews, clear packages, and dates you can lock.',
          image: '/images/02_-_HERO.webp',
          href: '/how-it-works',
        },
        {
          title: 'Run events that scale',
          body: 'Brand activations and corporate gatherings — the same calm book flow, bigger production.',
          image:
            'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1200&q=80',
          href: '/browse-vendors',
        },
      ],
      stories_title: 'If walls could talk',
      stories_body: 'Stories, tips, and host notes from the parties booked on VendaList.',
      stories_link_label: 'Read the journal',
      stories: WALLS_COULD_TALK,
      destinations_title: 'New places, new possibilities',
      destinations_body: 'Browse vendors by city — swap these cards whenever the markets change.',
      destinations: DESTINATIONS,
      host_eyebrow: 'For vendors',
      host_title: 'List your booth. Get booked.',
      host_body:
        'Set your packages, open your calendar, and let the right parties find you.',
      host_primary_label: 'Become a vendor',
      host_primary_link: '/register',
      host_secondary_label: 'How hosting works',
      host_secondary_link: '/how-it-works',
      host_image:
        'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1400&q=80',
      audience_cta_label: 'Start browsing',
      audience_cta_link: '/browse-vendors',
      hero_images: [],
      closing_title: 'Your something starts somewhere',
      closing_body: 'Browse vendors, compare packages, and book the night that feels inevitable.',
      closing_primary_label: 'Browse vendors',
      closing_primary_link: '/browse-vendors',
      closing_secondary_label: 'How it works',
      closing_secondary_link: '/how-it-works',
    },
  },
  {
    slug: 'about',
    label: 'About us',
    path: '/about',
    sections: [
      section('hero', 'Hero', 'hero', 'Charcoal collage. The headline sits in the center. The first six photos frame it.', [
        text('Headline', 'title'),
        list('Collage photos', 'collage', [image('Image', 'src')]),
      ]),
      section('mission', 'Mission', 'main', 'White band under the collage: eyebrow, headline, paragraphs, and button.', [
        text('Eyebrow', 'subtitle'),
        text('Headline', 'mission_title'),
        area('Body', 'content'),
        text('Button label', 'cta_text'),
        text('Button link', 'cta_link'),
      ]),
      section('audiences', 'Guests and vendors', 'main', 'Two cards side by side.', [
        list('Cards', 'audiences', [
          text('Eyebrow', 'eyebrow'),
          text('Headline', 'title'),
          area('Body', 'description'),
          text('Button label', 'cta'),
          text('Button link', 'href'),
        ]),
      ]),
      section('careers', 'Careers band', 'main', 'Dark band with copy on the left and a photo on the right.', [
        text('Eyebrow', 'careers_eyebrow'),
        text('Headline', 'careers_title'),
        area('First paragraph', 'careers_body'),
        area('Second paragraph', 'careers_body_2'),
        text('Button label', 'careers_cta'),
        text('Button link', 'careers_link'),
        image('Photo', 'careers_image'),
      ]),
      section('contact', 'Get in touch', 'main', 'Three columns at the bottom of the page.', [
        text('Eyebrow', 'contact_eyebrow'),
        text('Headline', 'contact_title'),
        list('Columns', 'contact_blocks', [
          text('Title', 'title'),
          area('Body', 'body'),
          text('Link label', 'linkLabel'),
          text('Link', 'href'),
        ]),
      ]),
    ],
    defaults: {
      subtitle: 'About us',
      title: 'Welcome to where extraordinary begins',
      mission_title: 'We have just the vendors',
      content:
        'VendaList opens doors to verified event vendors — photo booths, photography, entertainment, and more — so you can meet, create, and celebrate without the guesswork.\n\nOur network helps planners fulfill a vision, while vendors earn by listing clear packages and opening their calendars to the right occasions.',
      cta_text: 'Browse vendors',
      cta_link: '/browse-vendors',
      collage: [
        { src: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=800&q=80' },
        { src: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1000&q=80' },
        { src: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=800&q=80' },
        { src: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=900&q=80' },
        { src: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?auto=format&fit=crop&w=800&q=80' },
        { src: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=800&q=80' },
      ],
      audiences: [
        {
          eyebrow: 'Guests',
          title: 'Find a vendor. Fulfill your vision.',
          description: 'Meet, create, and celebrate with photo-led listings, clear packages, and reviews — in markets near you.',
          cta: 'Browse vendors',
          href: '/browse-vendors',
        },
        {
          eyebrow: 'Vendors',
          title: 'Your next booking might start here.',
          description: 'List your booth, crew, or service. Set packages, open availability, and get discovered by planners already searching.',
          cta: 'Become a vendor',
          href: '/vendor-signup',
        },
      ],
      careers_eyebrow: 'Careers',
      careers_title: 'Join our team',
      careers_body: 'Our people are the heart of VendaList. We build a calm, useful marketplace where planners book with confidence and vendors get discovered for the right events.',
      careers_body_2: 'If that sounds like work you want to do, we’d love to hear from you.',
      careers_cta: 'View open roles',
      careers_link: '/careers',
      careers_image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80',
      contact_eyebrow: 'Get in touch',
      contact_title: 'We’re here when you need us',
      contact_blocks: [
        { title: 'General', body: 'Questions about VendaList, partnerships, or the product.', linkLabel: 'Contact us', href: '/contact' },
        { title: 'Support', body: 'Help with bookings, accounts, or using the marketplace.', linkLabel: 'Help center', href: '/help' },
        { title: 'Press', body: 'Media kits, announcements, and press inquiries.', linkLabel: 'Press room', href: '/press' },
      ],
    },
  },
  {
    slug: 'contact',
    label: 'Contact us',
    path: '/contact',
    sections: [
      section('hero', 'Hero', 'hero', 'Photo hero with the page title over it.', [
        text('Headline', 'title'),
        area('Supporting line', 'subtitle'),
        image('Hero image', 'image'),
      ]),
      section('intro', 'Intro', 'main', 'Short intro above the contact methods.', [
        text('Headline', 'intro_title'),
        area('Body', 'intro_body'),
      ]),
      section('details', 'Contact methods', 'main', 'Email, phone, and address cards.', [
        list('Cards', 'contact_cards', [
          text('Title', 'title'),
          area('Body', 'body'),
          text('Link', 'href'),
        ]),
      ]),
      section('form', 'Message form', 'main', 'Topic tabs and the send form. Name, email, and message stay as the form itself.', [
        list('Topics', 'tabs', [
          text('Id', 'id'),
          text('Label', 'label'),
        ]),
        text('Reply note', 'reply_note'),
        text('Button label', 'button_label'),
      ]),
    ],
    defaults: {
      title: 'Contact us',
      subtitle: 'Questions about bookings, vendors, or the product — send a note.',
      image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1800&q=80',
      intro_title: 'We’re easy to reach',
      intro_body: 'Pick a topic below so your message gets to the right team. Typical reply within one business day.',
      contact_cards: [
        { title: 'Email', body: 'hello@vendalist.com — we respond within 24 hours.', href: 'mailto:hello@vendalist.com' },
        { title: 'Phone', body: '1-800-VENDA-LIST · Mon–Fri, 9am–6pm EST', href: 'tel:1800836325478' },
        { title: 'Address', body: '123 Business Street, Accra, Ghana', href: '' },
      ],
      tabs: [
        { id: 'general', label: 'General' },
        { id: 'booking', label: 'Booking' },
        { id: 'technical', label: 'Technical' },
        { id: 'vendor', label: 'Vendor' },
      ],
      reply_note: 'We typically reply within 24 hours on business days.',
      button_label: 'Send message',
    },
  },
  {
    slug: 'browse',
    label: 'Browse',
    path: '/browse-vendors',
    sections: [
      section('header', 'Header', 'hero', 'Title and description above the vendor grid.', [
        text('Eyebrow', 'eyebrow'),
        text('Title', 'title'),
        area('Description', 'description'),
      ]),
      section('lookbook', 'Lookbook sidebar', 'main', 'The panel beside the vendor list: hero photos, vibe chips, and the short notes.', [
        text('Eyebrow', 'lookbook_eyebrow'),
        text('Location prefix', 'location_prefix'),
        text('Line when no location', 'lookbook_fallback'),
        list('Slides', 'lookbook', [
          text('Title', 'title'),
          text('Meta', 'meta'),
          image('Image', 'image'),
        ]),
        text('Vibe heading', 'vibe_title'),
        list('Vibe chips', 'vibes', [
          text('Label', 'label'),
          text('Search query', 'q'),
        ]),
        list('Notes', 'lookbook_steps', [
          text('Title', 'title'),
          area('Text', 'text'),
        ]),
        text('Button label', 'lookbook_cta'),
        text('Button link', 'lookbook_cta_link'),
      ]),
      section('empty', 'Empty state', 'main', 'Shown when no vendors match the filters.', [
        text('Empty title', 'empty_title'),
        area('Empty description', 'empty_body'),
      ]),
    ],
    defaults: {
      eyebrow: 'Marketplace',
      title: 'Browse vendors',
      description: 'Photo-led listings — filter by category, place, price, and rating.',
      lookbook_eyebrow: 'Lookbook',
      location_prefix: 'Near',
      lookbook_fallback: 'Made on Vendalist',
      lookbook: MADE_ON_VENDALIST.slice(0, 4),
      vibe_title: 'Explore by vibe',
      vibes: HERO_ACTIVITY_CHIPS,
      lookbook_steps: [
        { title: 'Browse the look', text: 'Photo-first listings with clear packages.' },
        { title: 'Talk details', text: 'Message vendors about date, vibe, and setup.' },
        { title: 'Book with clarity', text: 'Confirm pricing before you commit.' },
      ],
      lookbook_cta: 'List your services',
      lookbook_cta_link: '/vendor-signup',
      empty_title: 'No vendors found',
      empty_body: 'Try adjusting your search or filters. Only vendors with active services are shown.',
    },
  },
  {
    slug: 'how-it-works',
    label: 'How it works',
    path: '/how-it-works',
    sections: [
      section('hero', 'Hero', 'hero', 'Centered title, supporting line, and two buttons.', [
        text('Eyebrow', 'hero_badge'),
        text('Headline', 'hero_title'),
        area('Supporting line', 'hero_subtitle'),
        text('Primary button', 'hero_primary_label'),
        text('Primary link', 'hero_primary_link'),
        text('Secondary button', 'hero_secondary_label'),
        text('Secondary link', 'hero_secondary_link'),
      ]),
      section('steps', 'Guest journey', 'main', 'Alternating photo and step. Drag a step to move its photo with it.', [
        text('Eyebrow', 'steps_eyebrow'),
        text('Headline', 'steps_title'),
        list('Steps', 'steps', [
          text('Number', 'number'),
          text('Title', 'title'),
          area('Description', 'description'),
          image('Photo', 'image'),
          text('Icon', 'icon'),
        ]),
      ]),
      section('audiences', 'Planners and vendors', 'main', 'Two photo cards.', [
        text('Eyebrow', 'audiences_eyebrow'),
        text('Headline', 'audiences_title'),
        list('Cards', 'audiences', [
          text('Eyebrow', 'eyebrow'),
          text('Headline', 'title'),
          area('Body', 'description'),
          text('Button label', 'cta'),
          text('Button link', 'href'),
          image('Photo', 'image'),
        ]),
      ]),
      section('features', 'Why VendaList', 'main', 'Dark band of feature cards. Icon names: Shield, Star, CreditCard, MessageSquare, Calendar, Users, Search, CheckCircle.', [
        text('Eyebrow', 'features_eyebrow'),
        text('Headline', 'features_title'),
        area('Supporting line', 'features_subtitle'),
        list('Cards', 'features', [
          text('Icon', 'icon'),
          text('Title', 'title'),
          area('Description', 'description'),
        ]),
      ]),
      section('closing', 'Closing', 'main', 'Final call to action.', [
        text('Headline', 'cta_title'),
        area('Supporting line', 'cta_subtitle'),
        text('Primary button', 'cta_primary_label'),
        text('Primary link', 'cta_primary_link'),
        text('Secondary button', 'cta_secondary_label'),
        text('Secondary link', 'cta_secondary_link'),
      ]),
    ],
    defaults: {
      hero_badge: 'How it works',
      hero_title: 'Book vendors in four calm steps',
      hero_subtitle: 'Browse verified vendors, compare packages, and lock the date — from first search to event day.',
      hero_primary_label: 'Browse vendors',
      hero_primary_link: '/browse-vendors',
      hero_secondary_label: 'Become a vendor',
      hero_secondary_link: '/vendor-signup',
      steps_eyebrow: 'The guest journey',
      steps_title: 'From search to celebration',
      steps: [
        { number: '01', icon: 'Search', title: 'Search', description: 'What you need and where the party is — markets and categories, not guesswork.', image: 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80' },
        { number: '02', icon: 'Calendar', title: 'Compare', description: 'Portfolios, packages, and reviews side by side so the shortlist feels obvious.', image: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1200&q=80' },
        { number: '03', icon: 'CreditCard', title: 'Book', description: 'Lock the date with secure checkout, confirmation, and a clear path to event day.', image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1200&q=80' },
        { number: '04', icon: 'CheckCircle', title: 'Enjoy', description: 'Stay in touch with your vendor, get ready for the day, and enjoy the event.', image: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1200&q=80' },
      ],
      audiences_eyebrow: 'Two sides of the marketplace',
      audiences_title: 'Built for planners and vendors',
      audiences: [
        { eyebrow: 'For guests', title: 'Find. Compare. Book.', description: 'Photo-led listings, clear packages, and messaging — so planning feels lighter from the first search.', cta: 'Browse vendors', href: '/browse-vendors', image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1200&q=80' },
        { eyebrow: 'For vendors', title: 'List. Get discovered. Get booked.', description: 'Open your calendar, set packages, and show up in searches from planners already looking in your market.', cta: 'Become a vendor', href: '/vendor-signup', image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=1200&q=80' },
      ],
      features_eyebrow: 'Why VendaList',
      features_title: 'Why book on VendaList',
      features_subtitle: 'Clarity, trust, and a calm path from shortlist to booked.',
      features: [
        { icon: 'Shield', title: 'Verified vendors', description: 'Providers are checked so you can book with more confidence.' },
        { icon: 'Star', title: 'Real reviews', description: 'Read feedback from past clients before you decide.' },
        { icon: 'CreditCard', title: 'Secure payments', description: 'Checkout is protected with industry-standard processing.' },
        { icon: 'MessageSquare', title: 'Direct messaging', description: 'Ask questions and customize details with the vendor.' },
        { icon: 'Calendar', title: 'Easy scheduling', description: 'See availability and book your preferred date.' },
        { icon: 'Users', title: 'Support when you need it', description: 'Our team helps if something goes sideways.' },
      ],
      cta_title: 'Ready when the date is',
      cta_subtitle: 'Search once, shortlist fast, book with confidence.',
      cta_primary_label: 'Browse vendors',
      cta_primary_link: '/browse-vendors',
      cta_secondary_label: 'Create account',
      cta_secondary_link: '/register',
    },
  },
  {
    slug: 'blog',
    label: 'Blog',
    path: '/blog',
    note: 'Articles themselves are edited under Blog Posts. This screen is the page around them.',
    sections: [
      section('hero', 'Hero', 'hero', 'Photo hero above the journal.', [
        text('Headline', 'title'),
        area('Supporting line', 'subtitle'),
        image('Hero image', 'image'),
      ]),
      section('intro', 'Intro', 'main', 'Short intro under the hero.', [
        text('Headline', 'intro_title'),
        area('Body', 'intro_body'),
      ]),
      section('posts', 'Articles', 'live', 'Featured story and the article grid come from Blog Posts. Drag this block to move it.'),
      section('closing', 'Newsletter', 'main', 'Dark subscribe band at the bottom.', [
        text('Headline', 'closing_title'),
        area('Supporting line', 'closing_body'),
        text('Button label', 'closing_button'),
        text('Email placeholder', 'closing_placeholder'),
      ]),
    ],
    defaults: {
      title: 'Event planning ideas',
      subtitle: 'Tips, guides, and inspiration — from weddings to corporate gatherings.',
      image: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?auto=format&fit=crop&w=1800&q=80',
      intro_title: 'Resources & inspiration',
      intro_body: 'Practical guides for planning celebrations — browse by topic or start with a featured story.',
      closing_title: 'Stay updated',
      closing_body: 'Get planning tips and guides in your inbox.',
      closing_button: 'Subscribe',
      closing_placeholder: 'Enter your email',
    },
  },
  {
    slug: 'safety',
    label: 'Safety',
    path: '/safety',
    sections: [
      section('hero', 'Hero', 'hero', 'Photo hero with two buttons.', [
        text('Headline', 'hero_title'),
        area('Supporting line', 'hero_subtitle'),
        image('Hero image', 'hero_image'),
        text('Primary button', 'hero_primary_label'),
        text('Secondary button', 'hero_secondary_label'),
        text('Secondary link', 'hero_secondary_link'),
      ]),
      section('intro', 'Intro', 'main', 'Opening paragraphs.', [
        text('Headline', 'intro_title'),
        area('Body', 'intro_body'),
      ]),
      section('guidelines', 'Protection cards', 'main', 'Grid of safety points.', [
        list('Cards', 'guidelines', [
          text('Title', 'title'),
          area('Description', 'description'),
        ]),
      ]),
      section('stories', 'Story pair', 'main', 'Two photos with titles and links.', [
        list('Stories', 'stories', [
          image('Image', 'image'),
          text('Title', 'title'),
          area('Body', 'description'),
          text('Link label', 'linkLabel'),
          text('Link', 'to'),
        ]),
      ]),
      section('emergency', 'Emergency note', 'main', 'Shown when a title or body is filled in.', [
        text('Headline', 'emergency_title'),
        area('Body', 'emergency_body'),
        text('Phone', 'emergency_phone'),
        text('Report button', 'emergency_button'),
      ]),
      section('closing', 'Closing', 'main', 'Dark help band.', [
        text('Headline', 'closing_title'),
        area('Supporting line', 'closing_body'),
        text('Primary button', 'closing_primary_label'),
        text('Primary link', 'closing_primary_link'),
        text('Secondary button', 'closing_secondary_label'),
        text('Secondary link', 'closing_secondary_link'),
      ]),
    ],
    defaults: {
      hero_title: 'Creating a safe, trustworthy marketplace',
      hero_subtitle: 'Safety for vendors and clients — so every booking can focus on the event.',
      hero_image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1800&q=80',
      hero_primary_label: 'How we protect you',
      hero_secondary_label: 'Report a problem',
      hero_secondary_link: '/report',
      intro_title: 'Trust & safety with you in mind',
      intro_body: 'VendaList brings people together for real events. We’re committed to the safety of clients and vendors — a trustworthy marketplace is the foundation of every booking.\n\nHere’s what we do behind the scenes to reduce risk and create peace of mind before, during, and after your event.',
      guidelines: [
        { title: 'Risk monitoring', description: 'We watch for unusual booking activity.' },
        { title: 'Identity verification', description: 'Vendors and clients are reviewed before listing.' },
        { title: 'Clear policies', description: 'Community guidelines everyone agrees to follow.' },
        { title: 'Liability awareness', description: 'Guidance so events stay covered and calm.' },
        { title: 'Protected payments', description: 'Checkout stays on-platform and secure.' },
        { title: 'Real reviews', description: 'Feedback from completed bookings only.' },
        { title: 'Fraud protection', description: 'Keep messaging and payments inside VendaList.' },
        { title: 'Additional safety', description: 'Tips for day-of hosting and attending.' },
      ],
      stories: [
        { image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80', title: 'Protecting the community', description: 'We’re committed to a respectful marketplace — clear expectations for vendors, clients, and day-of events.', linkLabel: 'Report a problem', to: '/report' },
        { image: 'https://images.unsplash.com/photo-1517935703315-d146452819c0?auto=format&fit=crop&w=1200&q=80', title: 'How to report issues', description: 'If something feels off before, during, or after a booking, tell us. We review every report carefully.', linkLabel: 'Contact support', to: '/contact' },
      ],
      emergency_title: '',
      emergency_body: '',
      emergency_phone: '',
      emergency_button: '',
      closing_title: 'Need help? We’re here.',
      closing_body: 'Support is available for questions and safety escalations.',
      closing_primary_label: 'Contact support',
      closing_primary_link: '/contact',
      closing_secondary_label: 'Help center',
      closing_secondary_link: '/help',
    },
  },
  {
    slug: 'help',
    label: 'Help center',
    path: '/help',
    note: 'The questions themselves are edited under FAQs.',
    sections: [
      section('hero', 'Hero', 'hero', 'Photo hero and the search field.', [
        text('Headline', 'title'),
        area('Supporting line', 'subtitle'),
        image('Hero image', 'image'),
        text('Search placeholder', 'search_placeholder'),
      ]),
      section('intro', 'Intro', 'main', 'Line above the questions.', [
        text('Headline', 'intro_title'),
        area('Body', 'intro_body'),
      ]),
      section('faqs', 'Questions', 'live', 'Topic tabs and answers come from FAQs. Drag this block to move it. The heading below is the title above the list.', [
        text('Heading', 'faq_heading'),
      ]),
      section('contact', 'Still need help', 'main', 'Support cards under the questions.', [
        text('Headline', 'contact_title'),
        list('Cards', 'contact_cards', [
          text('Title', 'title'),
          area('Body', 'body'),
          text('Link', 'href'),
        ]),
      ]),
      section('closing', 'Closing', 'main', 'Dark band at the bottom.', [
        area('Line', 'closing_body'),
        text('Link label', 'closing_link_label'),
        text('Link', 'closing_link'),
        text('Button label', 'closing_button'),
        text('Button link', 'closing_button_link'),
      ]),
    ],
    defaults: {
      title: 'Help center',
      subtitle: 'Answers to common questions — search below or browse by topic.',
      image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1800&q=80',
      search_placeholder: 'Search help…',
      intro_title: 'Find what you need',
      intro_body: 'Browse FAQs by topic, or reach support directly if you need a person. We’re here for bookings, payments, accounts, and safety questions.',
      faq_heading: 'Frequently asked questions',
      contact_title: 'Still need help?',
      contact_cards: [
        { title: 'Contact', body: 'Send us a message through the contact form.', href: '/contact' },
        { title: 'Email', body: 'support@example.com', href: 'mailto:support@example.com' },
        { title: 'Phone', body: '1-800-000-0000', href: 'tel:18000000000' },
        { title: 'Safety', body: 'Trust, reporting, and community guidelines.', href: '/safety' },
      ],
      closing_body: 'Prefer a full message?',
      closing_link_label: 'Contact us',
      closing_link: '/contact',
      closing_button: 'Contact support',
      closing_button_link: '/contact',
    },
  },
  {
    slug: 'careers',
    label: 'Careers',
    path: '/careers',
    sections: [
      section('hero', 'Hero', 'hero', 'Photo hero and the two buttons.', [
        text('Headline', 'title'),
        area('Supporting line', 'subtitle'),
        image('Hero image', 'image'),
        text('Primary button', 'hero_primary_label'),
        text('Secondary button', 'hero_secondary_label'),
        text('Secondary link', 'hero_secondary_link'),
      ]),
      section('intro', 'Intro', 'main', 'Opening copy.', [
        text('Headline', 'intro_title'),
        area('First paragraph', 'intro_body'),
        area('Second paragraph', 'intro_body_2'),
      ]),
      section('values', 'Values', 'main', 'Four culture cards.', [
        list('Cards', 'values', [
          text('Title', 'title'),
          area('Description', 'description'),
        ]),
      ]),
      section('roles', 'Open positions', 'main', 'Job list. Apply links to the contact form with the role title.', [
        text('Headline', 'roles_title'),
        area('Supporting line', 'roles_body'),
        list('Roles', 'roles', [
          text('Department', 'department'),
          text('Title', 'title'),
          area('Description', 'description'),
          text('Location', 'location'),
          text('Type', 'type'),
        ]),
      ]),
      section('benefits', 'Benefits', 'main', 'Benefit cards.', [
        text('Headline', 'benefits_title'),
        list('Cards', 'benefits', [
          text('Title', 'title'),
          area('Description', 'description'),
        ]),
      ]),
      section('closing', 'Closing', 'main', 'Dark call to action.', [
        text('Headline', 'closing_title'),
        area('Supporting line', 'closing_body'),
        text('Button label', 'closing_button'),
        text('Button link', 'closing_link'),
      ]),
    ],
    defaults: {
      title: 'Join our team',
      subtitle: 'Our people are the heart of VendaList. Build the marketplace that helps events come to life.',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1800&q=80',
      hero_primary_label: 'View open positions',
      hero_secondary_label: 'About VendaList',
      hero_secondary_link: '/about',
      intro_title: 'Work that shapes celebrations',
      intro_body: 'We’re connecting clients with exceptional vendors — and building a healthy culture where people are excited to show up and make an impact.',
      intro_body_2: 'If that sounds like you, get in touch. We’d love to talk.',
      values: [
        { title: 'Collaborative culture', description: 'Work with people who care about making events memorable.' },
        { title: 'Growth opportunities', description: 'Learning, mentorship, and clear paths to advance.' },
        { title: 'Work-life balance', description: 'Sustainable practices and flexible arrangements.' },
        { title: 'Real impact', description: 'Help connect people with exceptional event experiences.' },
      ],
      roles_title: 'Open positions',
      roles_body: 'Don’t see a perfect fit? Reach out anyway — we’re always curious about great people.',
      roles: [
        { department: 'Engineering', title: 'Senior Full-Stack Developer', description: 'Build and scale our platform using modern technologies. Lead initiatives and mentor juniors.', location: 'Remote / Accra, Ghana', type: 'Full-time' },
        { department: 'Design', title: 'Product Designer', description: 'Design calm, intuitive experiences. Work closely with product and engineering.', location: 'Remote / Accra, Ghana', type: 'Full-time' },
        { department: 'Operations', title: 'Customer Success Manager', description: 'Help clients and vendors succeed. Build relationships and drive satisfaction.', location: 'Accra, Ghana', type: 'Full-time' },
        { department: 'Marketing', title: 'Marketing Specialist', description: 'Grow our user base and brand with clear, thoughtful campaigns.', location: 'Remote / Accra, Ghana', type: 'Full-time' },
        { department: 'Sales', title: 'Business Development Representative', description: 'Onboard vendors and expand the marketplace through partnerships.', location: 'Accra, Ghana', type: 'Full-time' },
        { department: 'Analytics', title: 'Data Analyst', description: 'Turn platform data into insights that guide product and growth.', location: 'Remote', type: 'Full-time' },
      ],
      benefits_title: 'Benefits',
      benefits: [
        { title: 'Health coverage', description: 'Medical benefits for you and dependents.' },
        { title: 'Flexible work', description: 'Remote-friendly schedules that respect life outside work.' },
        { title: 'Learning budget', description: 'Courses, conferences, and tools to grow.' },
        { title: 'Equity & PTO', description: 'Competitive pay, equity, and generous time off.' },
      ],
      closing_title: 'Ready to build with us?',
      closing_body: 'Tell us what you’re great at — we’ll find the right conversation.',
      closing_button: 'Get in touch',
      closing_link: '/contact?subject=Careers',
    },
  },
  {
    slug: 'press',
    label: 'Press',
    path: '/press',
    sections: [
      section('hero', 'Hero', 'hero', 'Photo hero and the two buttons.', [
        text('Headline', 'title'),
        area('Supporting line', 'subtitle'),
        image('Hero image', 'image'),
        text('Primary button', 'hero_primary_label'),
        text('Secondary button', 'hero_secondary_label'),
        text('Secondary link', 'hero_secondary_link'),
      ]),
      section('intro', 'Intro', 'main', 'Short intro under the hero.', [
        text('Headline', 'intro_title'),
        area('Body', 'intro_body'),
      ]),
      section('releases', 'Latest releases', 'main', 'News items.', [
        text('Headline', 'releases_title'),
        list('Releases', 'releases', [
          text('Date', 'date'),
          text('Category', 'category'),
          text('Title', 'title'),
          area('Body', 'description'),
        ]),
      ]),
      section('kit', 'Media kit', 'main', 'Asset cards.', [
        text('Headline', 'kit_title'),
        list('Items', 'kit', [
          text('Title', 'title'),
          area('Description', 'description'),
        ]),
      ]),
      section('closing', 'Media inquiries', 'main', 'Dark band at the bottom.', [
        text('Headline', 'closing_title'),
        area('Supporting line', 'closing_body'),
        text('Button label', 'closing_button'),
        text('Button link', 'closing_link'),
      ]),
    ],
    defaults: {
      title: 'Press center',
      subtitle: 'Latest news and media resources for journalists and partners.',
      image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1800&q=80',
      hero_primary_label: 'View releases',
      hero_secondary_label: 'Media inquiry',
      hero_secondary_link: '/contact?subject=Press%20inquiry',
      intro_title: 'News & resources',
      intro_body: 'For interviews, statements, or assets — start with the releases below, or contact the press team directly.',
      releases_title: 'Latest releases',
      releases: [
        { date: 'January 15, 2026', category: 'Company news', title: 'Platform reaches 10,000 active users', description: 'We’re excited to announce that our platform has reached 10,000 active users, marking a significant milestone in our mission to connect clients with exceptional vendors.' },
        { date: 'December 20, 2025', category: 'Product', title: 'Enhanced booking experience launches', description: 'We’ve launched new features including real-time availability, instant messaging, and improved search filters to make event planning even easier.' },
        { date: 'November 10, 2025', category: 'Partnerships', title: 'Partnership with top event venues', description: 'We’re thrilled to announce partnerships with leading event venues across the country, expanding our network of trusted partners.' },
        { date: 'October 5, 2025', category: 'Company news', title: 'Expansion into new markets', description: 'We’re expanding our services to new cities and regions, bringing our platform to more clients and vendors nationwide.' },
      ],
      kit_title: 'Media kit',
      kit: [
        { title: 'Brand logos', description: 'Logos and brand assets for coverage.' },
        { title: 'Product images', description: 'High-resolution product screenshots.' },
        { title: 'Fact sheet', description: 'Company information and statistics.' },
        { title: 'Team photos', description: 'Executive and team photography.' },
      ],
      closing_title: 'Media inquiries',
      closing_body: 'For interviews, assets, or statements — reach the press team.',
      closing_button: 'Contact press',
      closing_link: '/contact?subject=Press%20inquiry',
    },
  },
];

export const publicPageBySlug = (slug) => PUBLIC_PAGES.find((page) => page.slug === slug);

export function pageText(value, fallback) {
  if (typeof value === 'string' && value.trim() !== '') return value;
  return fallback;
}

export function pageList(value, fallback) {
  return Array.isArray(value) && value.length ? value : fallback;
}

export function sectionOrder(saved, slug) {
  const page = publicPageBySlug(slug);
  const fallback = (page?.sections || []).map((item) => item.id).filter(Boolean);
  const raw = saved?.section_order;
  if (!Array.isArray(raw) || raw.length === 0) return fallback;
  const known = new Set(fallback);
  const ordered = raw.filter((id) => known.has(id));
  fallback.forEach((id) => {
    if (!ordered.includes(id)) ordered.push(id);
  });
  return ordered;
}

export function pageValue(saved, seed, defaults, key) {
  const value = saved?.[key];
  if (Array.isArray(value) && value.length) return value;
  if (typeof value === 'string' && value.trim() !== '') return value;
  const fromSeed = seed?.[key];
  if (Array.isArray(fromSeed) && fromSeed.length) return fromSeed;
  if (typeof fromSeed === 'string' && fromSeed.trim() !== '') return fromSeed;
  return defaults?.[key];
}

export function seedFromSettings(slug, settings = {}) {
  if (!settings) return {};
  if (slug === 'home') {
    const images = Array.isArray(settings.home_hero_images)
      ? settings.home_hero_images.filter(Boolean)
      : [];
    const hero = images.length ? images : settings.home_hero_image ? [settings.home_hero_image] : [];
    return hero.length ? { hero_images: hero.map((src) => ({ src })) } : {};
  }
  if (slug === 'about') {
    return {
      subtitle: settings.about_subtitle,
      title: settings.about_title,
      content: settings.about_content,
      cta_text: settings.about_cta_text,
      cta_link: settings.about_cta_link,
    };
  }
  if (slug === 'how-it-works') {
    const hiw = settings.how_it_works || {};
    return {
      hero_badge: hiw.hero?.badge,
      hero_title: hiw.hero?.title,
      hero_subtitle: hiw.hero?.subtitle,
      hero_primary_label: hiw.hero?.primaryButtonText,
      hero_primary_link: hiw.hero?.primaryButtonLink,
      hero_secondary_label: hiw.hero?.secondaryButtonText,
      hero_secondary_link: hiw.hero?.secondaryButtonLink,
      steps: Array.isArray(hiw.steps) ? hiw.steps : undefined,
      features_title: hiw.features?.title,
      features_subtitle: hiw.features?.subtitle,
      features: hiw.features?.items,
      cta_title: hiw.cta?.title,
      cta_subtitle: hiw.cta?.subtitle,
      cta_primary_label: hiw.cta?.primaryButtonText,
      cta_primary_link: hiw.cta?.primaryButtonLink,
      cta_secondary_label: hiw.cta?.secondaryButtonText,
      cta_secondary_link: hiw.cta?.secondaryButtonLink,
    };
  }
  if (slug === 'safety') {
    const ss = settings.safety_settings || {};
    const stories = [];
    if (ss.verification?.[0]) {
      stories.push({
        title: ss.verification[0].title,
        description: ss.verification[0].description,
        linkLabel: 'Report a problem',
        to: '/report',
      });
    }
    if (ss.reporting?.[0]) {
      stories.push({
        title: ss.reporting[0].title,
        description: ss.reporting[0].description,
        linkLabel: 'Contact support',
        to: '/contact',
      });
    }
    return {
      hero_title: ss.hero?.title,
      hero_subtitle: ss.hero?.subtitle,
      guidelines: Array.isArray(ss.guidelines) && ss.guidelines.length >= 4 ? ss.guidelines : undefined,
      stories: stories.length ? stories : undefined,
      emergency_title: ss.emergency?.title,
      emergency_body: ss.emergency?.description,
      emergency_phone: ss.emergency?.phone,
      emergency_button: ss.emergency?.reportButtonText,
    };
  }
  if (slug === 'contact') {
    const email = settings.site_email;
    const phone = settings.site_phone;
    const address = settings.site_address;
    if (!email && !phone && !address) return {};
    return {
      contact_cards: [
        email
          ? { title: 'Email', body: `${email} — we respond within 24 hours.`, href: `mailto:${email}` }
          : null,
        phone
          ? {
              title: 'Phone',
              body: `${phone} · Mon–Fri, 9am–6pm EST`,
              href: `tel:${String(phone).replace(/[^\d+]/g, '')}`,
            }
          : null,
        address ? { title: 'Address', body: `${address}, Accra, Ghana`, href: '' } : null,
      ].filter(Boolean),
    };
  }
  if (slug === 'help') {
    const email = settings.site_email;
    const phone = settings.site_phone;
    if (!email && !phone) return {};
    return {
      contact_cards: [
        { title: 'Contact', body: 'Send us a message through the contact form.', href: '/contact' },
        email ? { title: 'Email', body: email, href: `mailto:${email}` } : null,
        phone
          ? { title: 'Phone', body: phone, href: `tel:${String(phone).replace(/[^\d+]/g, '')}` }
          : null,
        { title: 'Safety', body: 'Trust, reporting, and community guidelines.', href: '/safety' },
      ].filter(Boolean),
    };
  }
  return {};
}
